import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import { getInitials } from 'helpers';
import { useStore } from 'context/store';
import { API_URL } from "components/Fetch"

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60,
    lineHeight: "unset"
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const [{ user: { user } }] = useStore();

  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={`${API_URL}/${user.photo}`}
        to="/account"
      >
        {getInitials(`${user.first_name} ${user.last_name}`)}
      </Avatar>
      <Typography
        className={classes.name}
        variant="h4"
      >
        {`${user.first_name} ${user.last_name}`}
      </Typography>
      <Typography variant="body2">{user.email}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
